{
    "locale": "fr-FR",
    "error": {
        "unsupportedMethod": "Méthode non prise en charge : {method}"
    },
    "account": {
        "deleteTokenTooltip": "Supprimer définitivement le jeton ?",
        "deleteToken": "Supprimer le jeton",
        "apiAccountToken": "Jeton de compte API",
        "createApiToken": "Créer un nouveau jeton de compte API",
        "createToken": "Créer un jeton",
        "existingTokens": "Jetons existants",
        "noApiTokensCreated": "Aucun jeton de compte API n’a encore été créé.",
        "description": "Description",
        "createdOn": "Créé le",
        "token": "Jeton",
        "saveTokenWarning": "Enregistrez ce jeton avec soin, il ne pourra plus être affiché.",
        "hint": "Remarque",
        "tokenCopiedNotification": "Jeton copié dans le presse-papiers.",
        "registrationNotice": "Veuillez noter qu’une inscription à eInfo ne fonctionne qu’en tant que revendeur pré-enregistré.",
        "registrationDescription": "L’inscription ici vous donne non seulement accès à notre boutique, mais aussi à notre plateforme de connaissances eInfo :",
        "informationAvailableTitle": "Informations disponibles à tout moment et partout",
        "statusQuery": "Vérification du statut des offres et commandes",
        "downloadDocuments": "Téléchargement de l’offre, de la confirmation de commande et de la facture",
        "downloadImages": "Téléchargement de l’image 2D/3D ainsi que du fichier DXF",
        "tracking": "Suivi de livraison",
        "customerLink": "Informer les clients et les partenaires via un lien",
        "recognizeChargeable": "Reconnaître directement les opérations payantes",
        "viewInvoices": "Afficher les factures envoyées dans la commande",
        "andMore": "Et bien plus.",
        "oneClickSolutionTitle": "Solution en un clic",
        "inquiryExample": "Soumettre une demande (ex : modification d’offre)",
        "requestManual": "Demander la notice de montage",
        "registerNow": "Inscrivez-vous gratuitement maintenant :",
        "requestAccess": "Demander l’accès",
        "companyData": "Données de l’entreprise",
        "customerNumber": "Numéro client",
        "company": "Entreprise",
        "streetAndHouseNumber": "Rue et numéro",
        "postcode": "Code postal",
        "city": "Ville",
        "country": "Pays",
        "personalAccess": "Accès personnel",
        "salutation": "Civilité",
        "firstName": "Prénom",
        "lastName": "Nom",
        "position": "Poste",
        "email": "Email",
        "phone": "Téléphone",
        "mobilePhone": "Téléphone portable",
        "fax": "Fax",
        "user": "Utilisateur",
        "termsAcceptance": "J’ai lu les",
        "termsAndConditions": "Conditions d’utilisation",
        "privacyPolicy": "Politique de confidentialité",
        "submitRequest": "Envoyer la demande",
        "acknowledged": "reconnues et acceptées",
        "requestForwarded": "La demande a été transmise.",
        "resetPassword": "Réinitialiser le mot de passe",
        "passwordMismatch": "Le mot de passe et sa confirmation ne correspondent pas !",
        "passwordComplexity": "La complexité du mot de passe est insuffisante. Veuillez utiliser une combinaison de lettres (majuscules et minuscules), de chiffres et de caractères spéciaux avec au moins 8 caractères.",
        "passwordSetSuccess": "Votre mot de passe a été défini. Vous pouvez maintenant vous connecter avec vos identifiants.",
        "passwordChangeSuccess": "Votre mot de passe a été modifié.",
        "errorOccurred": "Une erreur s’est produite. Veuillez réessayer plus tard.",
        "passwordResetLinkSent": "Si un compte existe pour le nom d’utilisateur fourni, un lien de réinitialisation du mot de passe a été envoyé à l’adresse email associée.",
        "setPasswordTitle": "Définir un mot de passe",
        "setPasswordDescription": "Définissez un nouveau mot de passe pour votre compte. Vous pourrez ensuite vous connecter immédiatement.",
        "changePasswordTitle": "Modifier le mot de passe",
        "newPasswordPlaceholder": "nouveau mot de passe",
        "repeatPasswordPlaceholder": "répéter le mot de passe",
        "termsAndConditionsRead1": "J’ai lu les",
        "termsAndConditionsRead2": "reconnues et acceptées",
        "submitButton": "envoyer",
        "accessDenied": "Accès refusé !",
        "closeInfo": "Vos modifications demandées sont en cours de vérification.",
        "unlockColleague": "Déverrouiller le collègue",
        "sendChanges": "Envoyer les demandes de modification",
        "firstname": "Prénom",
        "lastname": "Nom",
        "submitChangeRequest": "Envoyer les demandes de modification",
        "accessNumber": "Numéro d’accès",
        "changeRequestInProgress": "Vos modifications demandées sont en cours de vérification.",
        "iAccept": "J’ai lu les",
        "haveRead": "acceptées",
        "request": "demande",
        "customerBase": "Base de clients",
        "documentationHTML": "<h2>Documentation</h2><p>Comment utiliser l’API, vous pouvez le trouver dans notre <a href=\"{frontendBase}/tibi-api/_/{namespace}/_/assets/redoc/\" target=\"_blank\">documentation API</a>.</p><p>L’API est une API REST que vous pouvez appeler avec n’importe quel client HTTP.</p><p>Pour l’authentification, vous devez insérer le jeton généré dans l’en-tête HTTP \"account-token-v1\".</p><h3>Exemple</h3><p><code>curl 'https://einfo.renzgroup.com/api/operation?limit=10&offset=0&sort=-insertTime'<br />&nbsp; -H \"accept: application/json\"<br />&nbsp; -H \"account-token-v1: TOKEN\"</code></p>"
    },
    "header": {
        "watchlist": "Liste de suivi",
        "processInformationSystem": "Système d’information de processus",
        "switchAccount": "Changer de compte",
        "changeMasterData": "Modifier les données principales",
        "changePassword": "Changer le mot de passe",
        "template": "Modèle",
        "more": "Plus",
        "priceCalculation": "Calcul des prix",
        "addressBook": "Carnet d’adresses",
        "integrations": "Intégrations",
        "token": "Jeton",
        "logout": "Se déconnecter",
        "login": "Se connecter",
        "copyrightPage": "Mentions légales",
        "logoutIn": "déconnexion dans {logoutInMinutes} min"
    },
    "notifications": {
        "successfulLogout": "Vous vous êtes déconnecté avec succès du système.",
        "failedLogout": "Une erreur est survenue lors de la connexion. Veuillez vérifier vos identifiants.",
        "resubmissionSuccessfullyUpdated": "Relance mise à jour avec succès.",
        "resubmissionSuccessfullyCreated": "Relance créée avec succès.",
        "changesGotSaved": "Les modifications ont été enregistrées avec succès."
    },
    "cart": {
        "cancel": "annuler",
        "moveToCart": "déplacer vers le panier",
        "move": "déplacer",
        "referenceOfferNotFound": "Offre de référence non trouvée",
        "mapping": {
            "refNumber": "Numéro de référence",
            "number": "Numéro",
            "endCustomerEmail": "E-mail du client final",
            "endCustomerPhone": "Téléphone du client final",
            "endCustomerAddress": {
                "label": "Adresse du client final",
                "name1": "Nom 1",
                "name2": "Nom 2",
                "name3": "Nom 3",
                "street": "Rue",
                "country": "Pays",
                "postcode": "Code postal",
                "city": "Ville"
            },
            "endCustomerVAT": "TVA client final",
            "sumEndCustomerPrice": "Prix client final",
            "sumEndCustomerPriceGross": "Prix client final TTC",
            "type": {
                "label": "Type",
                "1": "Offre",
                "2": "Commande"
            },
            "source": {
                "label": "Origine",
                "10": "Back Office",
                "20": "eConfig Pro (RIK)",
                "30": "eConfig (VR)",
                "31": "eAssist",
                "40": "RIT",
                "50": "eShop",
                "60": "eInfo",
                "80": "VU entreprises liées",
                "90": "LIK"
            },
            "statusSummary": {
                "label": "Résumé du statut",
                "created": {
                    "label": "Créé",
                    "0": "non",
                    "30": "en cours",
                    "100": "terminé"
                },
                "emailed": {
                    "label": "Envoyé par e-mail",
                    "0": "non",
                    "100": "oui"
                }
            },
            "orderedSummary": {
                "label": "Résumé de commande",
                "ordered": {
                    "label": "Commandé",
                    "0": "non",
                    "100": "oui"
                },
                "orderedCount": "Nombre commandé"
            },
            "endCustomerFullAddress": {
                "label": "Adresse complète du client final",
                "id": "ID",
                "insertTime": "Date d’insertion",
                "updateTime": "Date de mise à jour",
                "dealerNumber": "Numéro revendeur",
                "type": {
                    "label": "Type",
                    "person": "Personne",
                    "company": "Entreprise"
                },
                "vat": "TVA",
                "company": {
                    "label": "Entreprise",
                    "name": "Nom",
                    "vatId": "ID TVA",
                    "firstname": "Prénom",
                    "lastname": "Nom",
                    "paymentTerms": "Conditions de paiement"
                },
                "person": {
                    "label": "Personne",
                    "salutation": "Civilité",
                    "firstname": "Prénom",
                    "lastname": "Nom",
                    "parentCompany": "Société mère"
                },
                "location": {
                    "label": "Emplacement",
                    "street": "Rue",
                    "houseNumber": "N°",
                    "supplement": "Complément",
                    "postcode": "Code postal",
                    "city": "Ville",
                    "country": "Pays"
                },
                "contact": {
                    "label": "Contact",
                    "phone": "Téléphone",
                    "fax": "Fax",
                    "email": "E-mail",
                    "website": "Site web"
                },
                "customerNumber": "Numéro client",
                "priceCalculation": "Calcul du prix",
                "notModifyablePCalc": "Calcul du prix non modifiable",
                "deliveryAddress": {
                    "label": "Adresse de livraison",
                    "salutation": "Civilité",
                    "name1": "Nom 1",
                    "name2": "Nom 2",
                    "name3": "Nom 3",
                    "street": "Rue",
                    "country": "Pays",
                    "postcode": "Code postal",
                    "city": "Ville",
                    "phone": "Téléphone",
                    "fax": "Fax",
                    "email": "E-mail"
                }
            },
            "dealerNumber": "Numéro revendeur",
            "inquiryDate": "Date de la demande",
            "inquiryNumber": "Numéro de demande",
            "receiptDate": "Date de réception",
            "releaseDate": "Date de validation",
            "constructionProject": "Projet de construction",
            "constructionSite": "Chantier",
            "commission": "Commission",
            "residentialUnitsCount": "Nombre d’unités résidentielles",
            "deliveryAddress": {
                "label": "Adresse de livraison",
                "salutation": "Civilité",
                "name1": "Nom 1",
                "name2": "Nom 2",
                "name3": "Nom 3",
                "street": "Rue",
                "country": "Pays",
                "postcode": "Code postal",
                "city": "Ville",
                "phone": "Téléphone",
                "fax": "Fax",
                "email": "E-mail"
            },
            "inquiryContact": {
                "label": "Chargé de dossier / Commanditaire",
                "name": "Nom"
            },
            "endCustomer": {
                "label": "Client final",
                "name": "Nom"
            },
            "sumNetPrice": "Valeur marchande nette",
            "sumRetailPrice": "Prix conseillé",
            "clerk": {
                "label": "Chargé de dossier",
                "name": "Nom",
                "email": "E-mail"
            },
            "internalClerk": {
                "label": "Chargé interne",
                "name": "Nom"
            },
            "additionalPositions": {
                "label": "Positions supplémentaires",
                "number": "Numéro",
                "service": "Service",
                "description": "Description",
                "netPrice": "Prix net",
                "amount": "Quantité"
            },
            "documentTemplateTextContent": {
                "label": "Contenu texte du modèle de document",
                "emailSubject": "Objet de l’e-mail",
                "emailBody": "Corps de l’e-mail",
                "pdfIntro": "Introduction PDF",
                "pdfOutro": "Conclusion PDF",
                "preLetter": "Lettre d’accompagnement",
                "deliveryTime": "Délai de livraison",
                "paymentTerms": "Conditions de paiement",
                "contact": {
                    "label": "Contact",
                    "useLoggedInUserAsDefault": "Utiliser l’utilisateur connecté par défaut",
                    "name": "Nom",
                    "phone": "Téléphone",
                    "email": "E-mail",
                    "webUrl": "Site web"
                }
            },
            "positions": {
                "label": "Positions",
                "number": "Numéro",
                "type": "Type",
                "quantity": "Quantité",
                "orderQuantity": "Quantité commandée",
                "color": {
                    "label": "Couleur",
                    "code": "Code couleur",
                    "name": "Nom couleur"
                },
                "additionalItems": {
                    "label": "Articles supplémentaires",
                    "number": "Numéro",
                    "description": "Description",
                    "netPrice": "Prix net",
                    "service": "Service",
                    "amount": "Quantité"
                },
                "state": {
                    "label": "Statut",
                    "code": "Code",
                    "description": "Description",
                    "blockingIndicator": "Indicateur de blocage"
                },
                "delivery": {
                    "label": "Livraison",
                    "plannedDate": "Date prévue",
                    "plannedDateNew": "Nouvelle date prévue",
                    "plannedWeek": "Semaine prévue",
                    "actualDate": "Date réelle",
                    "shippingCompany": "Code transporteur"
                },
                "origin": {
                    "label": "Origine",
                    "operationNumber": "Numéro d’opération",
                    "positionNumber": "Numéro de position"
                },
                "residentialUnitsCount": "Nombre d’unités résidentielles",
                "residentialUnitsCountTotal": "Nombre total d’unités résidentielles",
                "rikNumber": "Numéro ECP",
                "productGroup": "Groupe de produits",
                "modelGroup": "Groupe de modèles",
                "installationType": "Type d’installation",
                "netPrice": "Prix net",
                "endCustomerPrice": "Prix client final",
                "endCustomerPriceGross": "Prix TTC client final",
                "retailPrice": "Prix conseillé",
                "alternativeTo": "Alternative à",
                "objectionPeriodEnd": "Fin de la période de contestation",
                "instructionsAvailable": "Instructions de montage disponibles",
                "specialCAD": "CAD spécial",
                "items": {
                    "label": "Éléments de position",
                    "sequenceNumber": "Numéro de séquence",
                    "amount": "Quantité",
                    "measureUnit": "Unité de mesure",
                    "number": "Numéro de commande",
                    "description": "Désignation"
                },
                "tracking": {
                    "label": "Suivi",
                    "sequenceNumber": "Numéro de séquence",
                    "trackingNumber": "Numéro de suivi",
                    "status": "Statut",
                    "receiver": "Destinataire"
                },
                "chargeable": "Frais applicables",
                "chargeableReason": "Motif des frais"
            }
        },
        "updated": "Le panier {name} a été mis à jour.",
        "updateFailedS": "Le panier {name} n’a pas pu être mis à jour !",
        "inCartTooltip": "Cette offre se trouve dans les paniers suivants :",
        "addToCartTooltip": "Ajouter au panier",
        "dataTakeover": "Reprendre les données de l’offre :",
        "dataOvertake": "Reprise des données",
        "missingRequiredFields": "Veuillez remplir tous les champs obligatoires !",
        "noDataAvailable": "Aucune donnée disponible pour cette position.",
        "moveOffer": "Déplacer l’offre vers un autre panier",
        "moveOfferDisabled": "Impossible de déplacer l’offre – aucun autre panier n’existe.",
        "copyOffer": "Copier l’offre dans un autre panier",
        "copyOfferDisabled": "Impossible de copier l’offre – aucun autre panier n’existe.",
        "deleteOffer": "Supprimer l’offre du panier",
        "moveOfferS": "Déplacer l’offre",
        "deliveryAddress": "Adresse de livraison",
        "created": "Le panier {name} a été créé.",
        "createFailed": "Le panier {name} n’a pas pu être créé !",
        "cart": "Panier",
        "carts": "Paniers",
        "copyOfferS": "Copier l’offre",
        "phoneNotificationChosen": "La notification téléphonique a été sélectionnée. Veuillez remplir les champs requis.",
        "cartDeleted": "Le panier a été supprimé.",
        "cartDeleteFailed": "Le panier n’a pas pu être supprimé !",
        "orderSent": "Commande envoyée.",
        "back": "Retour",
        "addressUpdated": "Adresse mise à jour.",
        "addressUpdateFailed": "L’adresse n’a pas pu être mise à jour. Veuillez vérifier les données !",
        "addressCreated": "Adresse ajoutée au carnet d’adresses.",
        "addressCreateFailed": "L’adresse n’a pas pu être ajoutée. Vérifiez vos données !",
        "orderFailed": "La commande n’a pas pu être envoyée !",
        "updateFailed": "Le panier n’a pas pu être mis à jour !",
        "costNotice": "Veuillez noter que des frais peuvent s’appliquer à l’avenir. Actuellement, aucun frais.",
        "phoneNotificationRequested": "Notification téléphonique souhaitée ?",
        "phoneNotification": "Téléphone d’avis",
        "editCart": "Modifier le panier",
        "deleteCart": "Supprimer le panier",
        "cartIcon": {
            "inCartTooltip": "Cette offre se trouve dans les paniers suivants : {foundInCarts}",
            "addMarkedItemsTooltip": "Ajouter toutes les positions marquées au panier",
            "addAllItemsTooltip": "Ajouter toutes les positions au panier"
        },
        "updateSuccess": "Nom du panier modifié.",
        "updateError": "Nom du panier non modifié !",
        "createSuccess": "Nouveau panier créé.",
        "createError": "Le nouveau panier n’a pas pu être créé !",
        "createNewCartName": "Nouveau panier",
        "addCart": "Ajouter un panier",
        "createSuccessNotification": "Le panier a été créé avec succès.",
        "deleteSuccessNotification": "Le panier a été supprimé avec succès.",
        "updateSuccessNotification": "Le panier a été mis à jour.",
        "updateErrorNotification": "Le panier n’a pas pu être mis à jour.",
        "noCartsCreated": "Aucun panier n’a encore été créé.",
        "deleteModalTitle": "Supprimer le panier",
        "deleteModalMessage": "Souhaitez-vous vraiment supprimer le panier <strong>{cartName}</strong> ?",
        "deleteButton": "Supprimer le panier",
        "total": "Total",
        "amountPos": "Nb. positions",
        "totalSum": "Montant total",
        "sendOrder": "Envoyer la commande",
        "saveData": "Données enregistrées",
        "lookInAddressBook": "Rechercher dans le carnet d’adresses",
        "deviatingShippingAddress": "Adresse de livraison différente",
        "homeAddress": "Adresse domicile",
        "shippingAddress": "Adresse de livraison",
        "commission": "Commission",
        "commissionPlaceholder": "Saisir la commission",
        "constructionProject": "Projet de construction",
        "constructionProjectPlaceholder": "Saisir le projet",
        "shipment": {
            "selectCalendarWeek": "Sélectionner une semaine calendaire",
            "dontShipBefore": "Ne pas livrer avant la semaine :"
        },
        "legend": {
            "legend": "Légende",
            "operationCreated": "Processus créé",
            "inProgress": "En cours",
            "offerCreated": "Offre créée",
            "mandatoryField": "Champ obligatoire"
        },
        "modals": {
            "copy": "Copier",
            "confirmDataTakeover": {
                "header": "Reprise des données",
                "body": "Souhaitez-vous reprendre les données de l’offre {number} dans le panier actuel ?",
                "cancel": "Annuler",
                "confirm": "Reprendre les données"
            },
            "deleteCartOperation": {
                "header": "Supprimer du panier",
                "body": "Souhaitez-vous vraiment supprimer l’offre {number} du panier ?",
                "cancel": "Annuler",
                "confirm": "Supprimer"
            },
            "addressUpdate": {
                "headerCreate": "Créer une adresse",
                "headerUpdate": "Mettre à jour l’adresse",
                "bodyCreate": "Souhaitez-vous vraiment créer cette adresse ?",
                "bodyUpdate": "Souhaitez-vous vraiment mettre à jour cette adresse ?",
                "cancel": "Annuler",
                "confirmCreate": "Créer",
                "confirmUpdate": "Mettre à jour"
            },
            "moveCartOperation": "Déplacer l’offre vers un autre panier",
            "copyCartOperation": "Copier l’offre dans d’autres paniers",
            "orderCart": {
                "header": "Commander le panier",
                "body": "Souhaitez-vous vraiment envoyer la commande {name} ?",
                "cancel": "Annuler",
                "confirm": "Envoyer la commande"
            },
            "cartDeletion": {
                "header": "Supprimer le panier",
                "body": "Le panier est vide. Souhaitez-vous supprimer le panier {name} ?",
                "cancel": "Annuler",
                "confirm": "Supprimer",
                "success": "Le panier a été supprimé.",
                "error": "Le panier n’a pas pu être supprimé !"
            }
        },
        "assignOperation": {
            "title": "Déplacer l’offre vers un panier",
            "newCartLabel": "Nouveau panier",
            "tooltipAddToCart": "Ajouter au panier",
            "cancelButtonLabel": "Annuler",
            "submitButtonLabel": "Ajouter",
            "invalidCartNameTooltip": "Nom de panier invalide. Vérifiez s’il existe déjà et s’il est correct.",
            "noCartNameTooltip": "Veuillez entrer ou sélectionner un nom de panier.",
            "selectCartTooltip": "Ajouter au panier"
        }
    },
    "tableColumns": {
        "source": {
            "label": "O",
            "tooltip": "Origine"
        },
        "dealerNumber": {
            "label": "N° client",
            "tooltip": "Numéro revendeur"
        },
        "releaseDate": {
            "label": "Date de l’offre"
        },
        "insertTimeOut1": {
            "label": "Date de l’offre"
        },
        "insertTimeOut2": {
            "label": "Date de confirmation"
        },
        "number": {
            "labelOffer": "N° offre",
            "labelOrder": "N° commande"
        },
        "countOfPositions": {
            "label": "Nb. pos.",
            "tooltip": "Nombre de positions"
        },
        "status": {
            "label": "Statut"
        },
        "canceled": {
            "label": "Annulé"
        },
        "chargeable": {
            "label": "Facturable",
            "tooltip": "Facturable",
            "labelShort": "F"
        },
        "inquiryDate": {
            "label": "Date de demande"
        },
        "releaseDateOrder": {
            "label": "Date de commande"
        },
        "endCustomerName": {
            "label": "Demande / Nom"
        },
        "inquiryNumber": {
            "labelInquiry": "N° demande",
            "labelOrder": "N° commande"
        },
        "constructionProject": {
            "label": "Projet"
        },
        "commission": {
            "label": "Commission"
        },
        "constructionSite": {
            "label": "Chantier"
        },
        "inquiryContact": {
            "label": "Chargé de dossier"
        },
        "lastUpdatedBy": {
            "label": "Dernière modification par"
        },
        "deliveryAddress": {
            "label": "Adresse de livraison",
            "noDeliveryAddress": "Pas d'adresse de livraison"
        },
        "endCustomerFullAddress": {
            "label": "Nom du client final",
            "address": "Adresse du client final"
        },
        "residentialUnitsCount": {
            "label": "UE",
            "tooltip": "Unités résidentielles"
        },
        "sumNetPrice": {
            "label": "Total"
        },
        "followUpListOwner": {
            "label": "Propriétaire de la liste"
        },
        "description": {
            "label": "Description"
        },
        "insertTime": {
            "label": "Créé le"
        },
        "lastUsed": {
            "label": "Dernière utilisation"
        }
    },
    "bookmarks": {
        "icon": {
            "editOwnResubmissionsOnly": "Vous ne pouvez modifier que vos propres rappels.",
            "removeFromWatchlist": "retirer de la liste",
            "addToWatchlist": "ajouter à la liste"
        },
        "addBookmarks": "Ajouter un signet",
        "addedBookmarks": "Signet ajouté",
        "removeBookmarks": "Supprimer le signet",
        "removedBookmarks": "Signet supprimé",
        "offers": "Offres",
        "orders": "Commandes",
        "outgoingOffers": "Offres sortantes",
        "orderConfirmations": "Confirmations de commande",
        "bookmarks": "Liste de favoris",
        "myBookmarks": "Ma liste",
        "fullTextSearch": "Recherche texte intégral",
        "resetFilter": "Réinitialiser les filtres"
    },
    "login": {
        "successNotification": "Vous avez été connecté avec succès au système eInfo.",
        "failNotification": "Une erreur s’est produite lors de la connexion. Veuillez vérifier vos identifiants.",
        "mfaNotification": "Une confirmation supplémentaire est requise. Veuillez entrer le code reçu par e-mail.",
        "unknownErrorNotification": "Erreur inconnue lors de la connexion.",
        "enterMfaCode": "Veuillez entrer le code reçu par e-mail.",
        "usernamePlaceholder": "Nom d’utilisateur",
        "passwordPlaceholder": "Mot de passe",
        "submitButton": "envoyer",
        "resetPassword": "Réinitialiser le mot de passe",
        "requestAccess": "Demander un accès",
        "login": "Connexion",
        "code": "Code"
    },
    "integrations": {
        "configIntegrations": "Intégration du configurateur",
        "iframeRecommendation": "Nous recommandons pour l'intégration de l’iFrame une hauteur minimale de <b>800px</b> et une largeur minimale de <b>1000px</b>.",
        "contactDataPrepopulation": "Préremplissage des données de contact (optionnel)",
        "useCustomerData": "Vous pouvez préremplir le configurateur avec les données de base de vos clients connectés.",
        "fieldsToPrepopulate": "Les champs suivants peuvent être préremplis et ajoutés via les noms de champ dans l’URL :",
        "dealerErrorHeader": "Le revendeur avec le numéro {dealerNumbers} n’est pas entièrement configuré pour l’utilisation dans le configurateur !",
        "dealerErrorInstructions": "Veuillez vérifier si le modèle d’offre est correctement configuré et activé dans le compte revendeur.",
        "preDefInsert": "Insérer le préremplissage dans le code {additionalInfo}",
        "iframePreview": "et aperçu de l’iFrame",
        "colorStyle": "Style de couleur",
        "selectColorStyle": "Sélectionner le style de couleur",
        "backgroundColor": "Couleur de fond (optionnel)",
        "dealerCustomer": "Client revendeur",
        "dealerCustomers": "Clients revendeurs",
        "enterNumberOrName": "Entrer le numéro / nom",
        "sourceCode": "Code source pour votre site Web",
        "preview": "Aperçu",
        "fieldName": "Nom du champ",
        "importance": "Importance",
        "example": "Exemple",
        "noEntriesFound": "Aucune entrée trouvée",
        "dealerIsntAvailable": "Le revendeur n’est pas configuré ou activé pour l’utilisation dans le configurateur.",
        "integrationsMap": {
            "firstname": "Prénom",
            "lastname": "Nom",
            "company": "Entreprise",
            "city": "Ville",
            "street": "Rue",
            "houseNumber": "Numéro",
            "postcode": "Code postal",
            "countryCode": "Code pays",
            "email": "E-mail",
            "phone": "Téléphone"
        }
    },
    "operationsLegend": {
        "legendTitle": "Légende",
        "createdOperation": "Processus créé",
        "inProgress": "En cours",
        "offerCreated": "Offre créée",
        "cancellation": "Annulation",
        "partialCancellation": "Annulation partielle",
        "statusDescriptionTitle": "Description des statuts",
        "notStarted": "non démarré",
        "inProcess": "en cours",
        "delayed": "retardé",
        "partlyDone": "partiellement terminé",
        "completed": "terminé",
        "orderConfirmation": "Confirmation de commande",
        "objectionPeriod": "Période de contestation",
        "manufacture": "Fabrication",
        "shipping": "Expédition",
        "delivery": "Livraison"
    },
    "followUp": {
        "onMyList": "sur ma liste",
        "ownAndForeign": "Vous avez {total} relance(s) en retard, dont {ownCount} à vous et {foreignCount} d’autres.",
        "onlyOwn": "Vous avez {total} relance(s) en retard.",
        "added": "Relance ajoutée",
        "removed": "Relance supprimée"
    },
    "operations": {
        "shareTransaction": "partager cette opération via un lien",
        "inquiryS": "Demande concernant {opNumber}",
        "inquiryContact": "Chargé de dossier",
        "protocol": "Protocole pour {opNumber}",
        "email": "E-mail pour {opNumber}",
        "offerType1": "{offerTabTitle_Type1} {opNumber}",
        "orderConfirmation": "Confirmation de commande {opNumber}",
        "orderS": "Commande {opNumber}",
        "offerT": "Offre",
        "offer": "Envoyer une demande concernant toute l'offre",
        "linkSent": "Le lien a été envoyé avec succès à '{email}'.",
        "invalidEmail": "'{email}' n'est pas une adresse e-mail valide.",
        "showPositionDetails": "Afficher les détails de la position.",
        "incompleteOperation": "Ce processus n’est pas encore complètement créé.",
        "linkRegenerated": "Le lien a été régénéré. L'ancien lien n'est plus valide.",
        "linkDeactivated": "Le lien a été désactivé.",
        "linkCopied": "Le lien a été copié dans le presse-papiers.",
        "linkCopyFailed": "Échec de la copie du lien dans le presse-papiers. {text}",
        "order": "Commande",
        "share": "Partager",
        "linkDescription": "Ce lien permet à d’autres personnes (ex. clients) de consulter ce processus.",
        "noPriceInfo": "Aucune information tarifaire n’est visible pour ces personnes via le lien.",
        "copyLinkHint": "Copiez le lien ici pour le transmettre manuellement.",
        "copyLink": "Copier le lien",
        "regenerateLink": "Générer un nouveau lien",
        "regenerateLinkTooltip": "La génération d’un nouveau lien invalide l’ancien.",
        "deactivateLink": "Désactiver le lien",
        "deactivateLinkTooltip": "Le lien ne sera plus accessible après désactivation.",
        "sendLinkByEmail": "Envoyer le lien par e-mail",
        "enterEmailHint": "Saisissez l’adresse e-mail du destinataire et cliquez sur envoyer.",
        "emailPlaceholder": "Saisir l’e-mail du destinataire",
        "resetChanges": "Réinitialiser les modifications depuis la dernière sauvegarde.",
        "inquiryTitle": "Demande concernant",
        "generalInquiry": "Demande générale",
        "complaint": "Réclamation",
        "other": "Autre",
        "inquirySent": "Votre demande a été envoyée.",
        "operationNumber": "Processus {number}",
        "operationNotFound": "Processus {number} introuvable.",
        "position": "Position",
        "topic": "Sujet",
        "selectTopic": "Sélectionner un sujet",
        "message": "Message",
        "submit": "Envoyer",
        "source": "Origine",
        "customerNumber": "N° client",
        "orderNumber": "N° de commande",
        "outbound": "Sortant",
        "origin": "Origine",
        "numberOfPositions": "Nb. de positions",
        "status": "Statut",
        "cancellation": "Annulation",
        "orderDate": "Date de commande",
        "endCustomer": "Client final",
        "inquiryName": "Demande / Nom",
        "inquiryNumber": "N° de demande",
        "constructionProject": "Projet",
        "commission": "Commission",
        "constructionSite": "Chantier",
        "orderContact": "Commanditaire",
        "we": "UE",
        "residentialUnits": "Unités résidentielles",
        "sum": "Total",
        "inquiry": "Demande",
        "inquiryPlace": "Soumettre une demande",
        "inquiryOrder": "Demande concernant toute la commande",
        "deliveryAddress": "Adresse de livraison",
        "lastUpdatedBy": "Dernière modification par",
        "openCustomerOrderConfirmation": "Ouvrir la confirmation client",
        "openOriginalOrder": "Ouvrir la commande originale",
        "offerDate": "Date de l'offre",
        "offerNumber": "N° de l’offre",
        "openCustomerOffer": "Ouvrir l'offre client",
        "openOriginalOffer": "Ouvrir l’offre originale",
        "inquiryDate": "Date de la demande",
        "duplicateAndEdit": "Dupliquer <br/> et modifier",
        "head": {
            "origin": "Origine",
            "customerNumber": "N° client",
            "offerDate": "Date de l’offre",
            "orderConfirmationDate": "Date de <br/> confirmation de commande",
            "offerNr": "N° offre",
            "orderNr": "N° commande",
            "source": "Source",
            "openOriginalOffer": "Ouvrir l’offre originale",
            "openOriginalOrder": "Ouvrir la commande originale",
            "initialOffer": "Offre initiale",
            "noReferenceFound": "Aucune référence trouvée",
            "amountOfPositions": "Nb. positions",
            "status": "Statut",
            "inquiryDate": "Date de la demande",
            "editedLast": "Dernière modification <br /> par",
            "clerk": "Chargé de dossier",
            "yourReference": "Votre référence",
            "constructionProject": "Projet",
            "commission": "Commission"
        }
    },
    "operationsOut": {
        "entryNotFound": "Entrée non trouvée.",
        "clickForMoreInfo": "Cliquez sur une entrée pour plus d'infos",
        "resetFilter": "Réinitialiser le filtre",
        "filter": "Filtre",
        "tableView": "Affichage en tableau",
        "gridView": "Affichage en grille",
        "orderConfirmation": "Confirmation de commande",
        "address": {
            "applyPriceGroup": "Appliquer le groupe tarifaire ?",
            "noPriceGroup": "Aucun groupe tarifaire défini pour cette adresse.",
            "resetGlobal": "Souhaitez-vous réinitialiser le calcul du prix selon la configuration globale ?",
            "partnerCompany": "Société du contact",
            "selectedAddress": "Adresse sélectionnée",
            "priceGroupApplied": "a le groupe tarifaire {priceGroup}. Souhaitez-vous l’appliquer à {documentType} ?",
            "currentOffer": "l'offre actuelle",
            "currentOrderConfirmation": "la confirmation de commande actuelle",
            "no": "non",
            "yes": "oui",
            "endCustomerAddress": "Adresse client final",
            "searchInAddressBook": "Rechercher dans le carnet d'adresses",
            "saveData": "Données enregistrées"
        }
    },
    "positions": {
        "specialRequestNoCharge": "Demande spéciale à un employé Renz – peut ne pas être rémunérée",
        "sequenceNumber": "N° séq.",
        "quantity": "Quantité",
        "unit": "Unité",
        "articleNumber": "Réf. article",
        "description": "Désignation",
        "offerNumber": "N° offre",
        "orderNumber": "N° commande",
        "position": "Position",
        "alternativeTo": "Alternative à",
        "fileAttachements": "Pièces jointes",
        "linkedIncomingOperations": "Opérations entrantes liées",
        "linkedOutgoingOperations": "Opérations sortantes liées",
        "texts": "Textes",
        "positionCoverLetter": "Lettre de position",
        "positionsTexts": "Textes des positions",
        "origin": "O.",
        "source": "Origine",
        "customerNumber": "N° client",
        "attachement": "Lien",
        "amountOfPositions": "Nb. positions",
        "status": "Statut",
        "date": "Date",
        "inquiryOrOrderNumber": "N° demande/commande",
        "commission": "Commission",
        "constructionProject": "Projet",
        "constructionSite": "Chantier",
        "residentialUnits": "UE",
        "residentialUnitsCountTooltip": "Unités résidentielles",
        "sum": "Total",
        "noAttachedOperations": "Aucune opération liée",
        "net": "net",
        "gross": "brut",
        "withoutAlternativePositions": "sans positions alternatives",
        "assemblyInstructionSent": "Les instructions de montage vous ont été envoyées par e-mail et sont aussi disponibles dans eInfo sous peu.",
        "errorOccurred": "Une erreur est survenue ! Veuillez réessayer plus tard.",
        "requestAssemblyInstruction": "Demander les instructions de montage",
        "enterEmailPrompt": "Veuillez saisir une adresse e-mail pour recevoir les instructions.",
        "sendAssemblyInstructionTo": "Envoyer les instructions de montage à",
        "submit": "Envoyer",
        "requestAssemblyInstructionBreak": "Demander les<br />instructions de montage",
        "deleteFromOperation": "Supprimer de l’opération",
        "confirmDeletePosition": "Souhaitez-vous vraiment supprimer la position \"<strong>{number}</strong>\" de l’opération ?",
        "deleteOperation": "Supprimer l’opération",
        "confirmDeleteLastPosition": "C’est la dernière position. Voulez-vous vraiment supprimer l’opération du panier ?",
        "restorePosition": "Restaurer la position",
        "confirmRestorePosition": "Souhaitez-vous vraiment restaurer la position \"<strong>{number}</strong>\" ?",
        "marginWarning": "Votre prix de vente est inférieur à votre prix d’achat.",
        "image": "Image",
        "positionShort": "Pos.",
        "quantityShort": "Qté",
        "chargeable": "Facturable",
        "productGroup": "Groupe de produits",
        "modelGroup": "Groupe de modèles",
        "color": "Couleur",
        "cancellation": "Annulation",
        "noCancellation": "Pas d’annulation",
        "deliveryDateFromFactory": "Date de livraison usine",
        "tracking": "Suivi colis",
        "ecpNumber": "N° ECP",
        "residentialUnitsShort": "UE",
        "infoToAgent": "Info au chargé de dossier",
        "unitPrice": "Prix unitaire",
        "actions": "Actions",
        "packagingAndShipping": "Emballage & expédition",
        "packagingAndShippingDescription": "Ce montant est facturé pour l’emballage et l’expédition.",
        "noPreviousEntry": "Aucune entrée précédente",
        "alternativeToPosition": "Alternative à la position {number}",
        "previousValue": "Valeur précédente",
        "amount": "Quantité",
        "sellingPrice": "Prix de vente",
        "purchasePrice": "Prix d'achat",
        "showPositionDetails": "Afficher les détails de la position.",
        "inquiry": "Demande",
        "inquiryForPosition": "Demander concernant cette position",
        "deletePosition": "Supprimer la position",
        "delete": "supprimer",
        "recreate": "Restaurer",
        "recreatePosition": "Restaurer la position",
        "noColorSpecification": "aucune couleur spécifiée",
        "addAdditionalService": "Ajouter une prestation supplémentaire",
        "RRP": "PVC",
        "endcustomer": "Client final",
        "margin": "Marge"
    },
    "priceCalculation": {
        "priceCalculation": "Calcul du prix",
        "globalPricegroup": "Groupe tarifaire global",
        "dealerNr": "N° revendeur",
        "manualInput": "Saisie manuelle"
    },
    "address": {
        "deliveryEqualsCompany": "l'adresse de livraison est identique à l'adresse de l'entreprise",
        "deliveryUnequalsCompany": "l'adresse de livraison est différente de l'adresse de l'entreprise",
        "customerNumberAlreadyTaken": "Numéro client déjà attribué.",
        "decideCompAndShipAddress": "Veuillez indiquer si l’adresse de l’entreprise est identique à l’adresse de livraison.",
        "fillOutMandatoryFields": "Veuillez remplir tous les champs obligatoires !",
        "editAddress": "Modifier l’adresse",
        "addPersonSuccess": "Contact ajouté avec succès.",
        "addAddressSuccess": "Nouvelle adresse créée avec succès.",
        "addPersonError": "Erreur lors de l’ajout du contact.",
        "addAddressError": "Erreur lors de la création de l’adresse.",
        "closeAddress": "Fermer l’adresse",
        "unsavedChanges": "Des modifications non enregistrées existent. Voulez-vous vraiment fermer le formulaire ?",
        "addressBook": "Carnet d’adresses",
        "contactPerson": "Personne de contact",
        "firstName": "Prénom",
        "lastName": "Nom",
        "companyName": "Nom de l’entreprise",
        "vatId": "ID TVA",
        "company2OrAdditionalAddress": "Entreprise 2 / Complément d’adresse",
        "noChangeToGlobalTaxRate": "Aucun changement du taux de TVA global",
        "postalCode": "Code postal",
        "vat": "TVA",
        "phone": "Téléphone",
        "paymentTerms": "Conditions de paiement",
        "fax": "Fax",
        "email": "E-mail",
        "website": "Site web",
        "contactPersonName": "CONTACT (NOM, PRÉNOM)",
        "assignedPriceGroup": "Groupe tarifaire attribué",
        "contactPersonSalutation": "CIVILITÉ DU CONTACT",
        "edit": "Modifier l’adresse",
        "delete": "Supprimer l’adresse",
        "createSuccess": "Nouvelle adresse créée avec succès.",
        "createError": "Erreur lors de la création de l’adresse.",
        "freeSearch": "Recherche libre",
        "enterSearchTerm": "Saisir un terme de recherche",
        "type": "Type",
        "company": "Entreprise",
        "salutation": "Civilité",
        "firstname": "Prénom",
        "lastname": "Nom",
        "street": "Rue",
        "houseNumber": "N°",
        "supplement": "Complément d’adresse",
        "postcode": "Code postal",
        "city": "Ville",
        "country": "Pays",
        "customerNumber": "N° client",
        "typeTooltipCompany": "Entreprise",
        "typeTooltipContactPerson": "Contact",
        "setNewAddress": "Créer une nouvelle adresse",
        "setNewEntry": "Créer une nouvelle entrée",
        "entry": "enregistrement",
        "editEntry": "Modifier l’entrée",
        "deleteContact": "Supprimer le contact",
        "saveData": "Données enregistrées",
        "reset": "⟳ réinitialiser",
        "notModified": "L’adresse n’a pas été modifiée.",
        "closeHeader": "Fermer l’adresse",
        "unsavedChangesWarning": "Des modifications non enregistrées existent. Voulez-vous vraiment fermer le formulaire ?",
        "contactDeletedSuccess": "Contact supprimé avec succès.",
        "resetChangesInfo": "Cela réinitialise toutes les modifications depuis la dernière sauvegarde.",
        "deleteError": "L’adresse n’a pas pu être supprimée !",
        "multipleDeleteSuccess": "{successfulDeletes} contacts et une adresse supprimés avec succès.",
        "partialDeleteError": "Certaines adresses n’ont pas pu être supprimées !",
        "unexpectedError": "Une erreur inattendue s’est produite !",
        "removeContactHeader": "Supprimer le contact",
        "deleteEntryHeader": "Supprimer l’entrée",
        "removeContactConfirm": "Voulez-vous vraiment supprimer ce contact ?",
        "deleteContactConfirm": "Souhaitez-vous vraiment supprimer ce contact du carnet d’adresses ? Tous les contacts liés seront également supprimés.",
        "cancelButton": "annuler",
        "removeButton": "supprimer",
        "deleteButton": "supprimer",
        "customerNumberLabel": "(N° client : {customerNumber})",
        "dealerNumberLabel": "(N° revendeur : {dealerNumber})",
        "dealerNr": "N° revendeur",
        "manualEntry": "Saisie manuelle",
        "newContact": "Nouveau contact",
        "fillRequiredFields": "Veuillez remplir tous les champs obligatoires !"
    },
    "components": {
        "additionalServices": {
            "addService": "Ajouter une prestation supplémentaire",
            "deleteService": "Supprimer une prestation supplémentaire",
            "amount": "Quantité",
            "service": "Prestation",
            "description": "Description",
            "price": "Prix (€)",
            "salesPrice": "Prix de vente :",
            "serviceToPosition": "Prestation liée à la position"
        },
        "additionalPosition": {
            "additionalPosition": "Position supplémentaire",
            "headingInPdf": "Titre dans le PDF",
            "addAdditionalPosition": "Ajouter une position supplémentaire",
            "additionalPositionAdd": "Ajouter une position additionnelle"
        },
        "operationsEmail": {
            "recipient": "Destinataire",
            "cc": "CC",
            "bcc": "CCI",
            "subject": "Objet",
            "message": "Message",
            "sendOfferSubject": "Offre client {number}",
            "sendOrderConfirmationSubject": "Confirmation de commande {number}",
            "sendOfferMessage": "Madame, Monsieur,\nVeuillez trouver ci-joint notre offre sans engagement concernant les positions demandées.\n\nCordialement,\n{firstName} {lastName} ({email})",
            "sendOrderConfirmationMessage": "Madame, Monsieur,\nVeuillez trouver ci-joint la confirmation de votre commande.\n\nCordialement,\n{firstName} {lastName} ({email})",
            "attachment": "Pièce jointe",
            "sendButton": "Envoyer",
            "offerSentNotification": "L'offre a été envoyée.",
            "orderConfirmationSentNotification": "La confirmation de commande a été envoyée.",
            "errorNotification": "Une erreur s’est produite. Veuillez réessayer ultérieurement.",
            "offerCouldNotBeSent": "L’offre n’a pas pu être enregistrée"
        },
        "operationDetails": {
            "manualPriceGroup": "Saisie manuelle",
            "globalPriceGroup": "Groupe tarifaire global",
            "dealerNumber": "N° revendeur",
            "offerTemplate": "Modèle d’offre",
            "orderConfirmationTemplate": "Modèle de confirmation de commande",
            "couldNotBeCreated": " n’a pas pu être créé",
            "offer": "Offre",
            "orderConfirmation": "Confirmation de commande",
            "isNotCompleted": " n’est pas encore finalisé, veuillez vérifier si un modèle valide est défini.",
            "wasSuccessfullySaved": " a été enregistré avec succès.",
            "offerCouldNotBeSaved": "L’offre n’a pas pu être enregistrée",
            "wasSuccessfullyCreated": " a été créé avec succès.",
            "saveToGeneratePDF": "Veuillez enregistrer le document pour générer le PDF.",
            "selectAtLeastOnePosition": "Veuillez sélectionner au moins une position",
            "markedPositionsToCart": "positions sélectionnées dans le panier",
            "convertToCustomerOffer": "en offre client",
            "convertToOrderConfirmation": "en confirmation de commande",
            "transformTo": "convertir en",
            "sendOfferToCustomer": "Envoyer l’offre au <br /> client",
            "createOrderConfirmationAndEdit": "Créer la confirmation de commande <br /> et modifier",
            "sendOrderConfirmationToCustomer": "Envoyer la confirmation de commande <br /> au client",
            "offerChanged": "L’offre a été modifiée, veuillez enregistrer !",
            "noCorrespondingOrder": "Aucune commande correspondante disponible. Veuillez patienter jusqu'à ce que la commande soit disponible dans le système Renz.",
            "orderCanceled": "La commande a été annulée.",
            "allPositionsCanceled": "Toutes les positions pertinentes de la commande ont été annulées.",
            "orderConfirmationChanged": "La confirmation de commande a été modifiée, veuillez enregistrer !",
            "orderConfirmationNotComplete": "La confirmation de commande n’est pas encore finalisée.",
            "offerAlreadySent": "L’offre a déjà été envoyée au client",
            "orderConfirmationAlreadySent": "La confirmation de commande a déjà été envoyée au client",
            "orderConfirmationTemplateError": "Le modèle de confirmation de commande n’a pas pu être créé : ",
            "offerNotChanged": "L’offre n’a pas été modifiée !",
            "orderConfirmationNotChanged": "La confirmation de commande n’a pas été modifiée !",
            "offerReset": "Réinitialiser l’offre à l’état sauvegardé",
            "orderConfirmationReset": "Réinitialiser la confirmation de commande à l’état sauvegardé",
            "orderNotComplete": "La commande n’est pas encore finalisée.",
            "offerNotCompleted": "L’offre n’est pas encore finalisée. Veuillez vérifier la présence du PDF. Si absent, vérifiez que le modèle est valide et enregistrez à nouveau !",
            "templateNotAvailable": "Aucun modèle défini ni pour votre numéro revendeur ni personnellement.",
            "offerDataInherited": "Les paramètres des offres d’origine des positions sont repris.",
            "invalid": "invalide",
            "dataFromIncomingOrder": "Les données de la commande entrante sont utilisées."
        },
        "table": {
            "changesInOperations": "Modifications du processus",
            "fieldName": "Nom du champ",
            "previousValue": "Valeur précédente",
            "currentValue": "Valeur actuelle",
            "watchlist": "Liste de favoris",
            "offerNumber": "Numéro d'offre",
            "transationStemsFrom": "Le processus provient d'une offre sortante",
            "offerGotChanged": "L’offre {offerNumber} a été modifiée en externe, la version révisée est affichée ici.",
            "noCurrentEntry": "Aucune entrée actuelle",
            "noEarlierEntry": "Aucune entrée précédente",
            "fields": {
                "attachmentField": {
                    "offer": "Offre",
                    "orderConfirmation": "Confirmation de commande",
                    "invoice": "Facture",
                    "deliveryNote": "Bon de livraison",
                    "twoDOverall": "Image 2D globale",
                    "twoDDetail1": "Détail 2D 1",
                    "twoDDetail2": "Détail 2D 2",
                    "twoDImage": "Image 2D",
                    "threeDImage": "Image 3D",
                    "assemblyInstruction": "Instructions de montage",
                    "dxfFile": "Fichier DXF"
                },
                "cancellation": {
                    "none": "aucune annulation",
                    "full": "toutes les positions annulées",
                    "partial": "annulation partielle"
                },
                "trackingList": {
                    "delivered": "livré",
                    "inDelivery": "en cours de livraison",
                    "inTransit": "en transit",
                    "noData": "aucune donnée disponible",
                    "externalLink": "lien externe vers {shippingCompany}",
                    "noTrackingLink": "aucun lien de suivi disponible",
                    "shippingCompany": "Transporteur : {shippingCompany}",
                    "receipt": "Accusé de réception : {receiver}"
                },
                "trackingField": {
                    "trackingLabel": "Suivi de colis",
                    "deliveredStatus": "{deliveredCount} sur {count} livrés",
                    "showDetails": "Afficher les détails",
                    "notAvailable": "non disponible"
                },
                "status": {
                    "orderConfirmation": "Confirmation de commande",
                    "shipping": "Expédition",
                    "manufacture": "Production",
                    "offerCreated": "Offre créée",
                    "offerInProgress": "Offre en cours",
                    "offerEmailSent": "E-mail de l’offre envoyé à {emailDetails}",
                    "noOfferEmailSent": "Aucun e-mail d’offre envoyé",
                    "emailDetails": "dernièrement à {recipient} le {timestamp}",
                    "orderConfirmationEmailSent": "E-mail de confirmation envoyé à {emailDetails}",
                    "noOrderConfirmationEmailSent": "Aucun e-mail de confirmation envoyé",
                    "inConfirmCount": "{count} position(s) en cours de traitement",
                    "orderConfirmed": "Commande confirmée",
                    "orderInProgress": "Commande en cours",
                    "objectionPeriod": "Période d’opposition",
                    "inObjectionPeriod": "{count} position(s) en période d'opposition",
                    "objectionPeriodExpiredForSome": "Période d’opposition expirée pour {count} position(s)",
                    "objectionPeriodExpired": "Période d’opposition expirée",
                    "objectionPeriodAfterConfirmation": "Période d’opposition commence après la confirmation",
                    "inManufacture": "{count} position(s) en production",
                    "manufactureCompleted": "Production terminée",
                    "noItemsInManufacture": "aucune position en production",
                    "inReadyToShip": "{count} position(s) en préparation d’expédition",
                    "readyToShipCompleted": "Préparation d’expédition terminée",
                    "noItemsReadyToShip": "aucune position en préparation",
                    "inShipment": "{count} position(s) expédiée(s)",
                    "delivered": "{count} position(s) livrée(s)",
                    "noItemsInShipment": "aucune position en livraison",
                    "missingTracking": "Aucune information de suivi complète disponible.",
                    "orderedMultiple": "Commandée {count} fois",
                    "notOrdered": "Pas encore commandée",
                    "fullyOrdered": "complètement commandée",
                    "orderedCount": "{count} position(s) commandée(s)",
                    "outboundOfferCreated": "Offre sortante créée",
                    "noOutboundOfferCreated": "Aucune offre sortante créée",
                    "orderConfirmationCreated": "Confirmation de commande créée",
                    "noOrderConfirmationCreated": "Aucune confirmation de commande créée",
                    "operationStatusUpdated": "Le statut du processus {operationNumber} a été défini sur {statusLabel} et la note a été mise à jour.",
                    "operationStatusOnlyUpdated": "Le statut du processus {operationNumber} a été défini sur {statusLabel}.",
                    "operationNoteUpdated": "La note du processus {operationNumber} a été mise à jour.",
                    "noPermissionToEditStatus": "Vous n’avez pas les droits pour modifier le statut.",
                    "defaultFirstName": "Prénom",
                    "defaultLastName": "Nom",
                    "operationTracking": "Suivi du processus {operationNumber}",
                    "status": "Statut",
                    "notes": "Notes",
                    "insertTimestampLine": "Insérer un horodatage",
                    "noNotesAvailable": "Aucune note disponible",
                    "clickIconToMakeChanges": "Cliquez sur l’icône pour modifier",
                    "inObjectionPeriodUntil": "Position en période d'opposition jusqu’au {date}",
                    "objectionPeriodExpiredOn": "Période d'opposition expirée{dateInfo}",
                    "dateOn": " le {date}",
                    "positionInManufacture": "Position en production",
                    "manufactureNotStarted": "Production non démarrée",
                    "positionDelivered": "Position livrée",
                    "positionShippedNoTracking": "Position expédiée\n\nAucune info de suivi disponible.",
                    "positionShipped": "Position expédiée",
                    "positionNotShipped": "Position non expédiée",
                    "positionReadyToShip": "Position prête à être expédiée",
                    "noPositionsInShipping": "aucune position en expédition"
                },
                "number": {
                    "offerNumber": "Offre / Numéro {operationNumber}",
                    "orderNumber": "Commande / Numéro {operationNumber}",
                    "positionNumber": "\nPosition {positionNumber}"
                },
                "chargeableField": {
                    "CAD": "Pos est désormais CAD spécial",
                    "NTF": "Pos est NetFix",
                    "BTF": "Pos est BrutFix",
                    "GNE": "Raison non identifiable",
                    "CPY": "Valeur initiale lors de la copie dans le Backoffice",
                    "SBE": "Ajout par le gestionnaire",
                    "BNI": "Clarification avec le gestionnaire RENZ ID",
                    "BNA": "Bonus désactivé au niveau en-tête = non éligible RIK",
                    "SW": "Souhait particulier du client",
                    "SBO": "Modification ultérieure par gestionnaire",
                    "SBA": "Modification ultérieure par gestionnaire",
                    "SBR": "Révocation suite à modif. manuelle des remises",
                    "SHO": "Saisi via eConfig",
                    "WVU": "Flux marchandises entre entités liées",
                    "QNR": "Commande RIT, non éligible RIK",
                    "chargeable": "Position éligible à rémunération.",
                    "notChargeable": "Position non éligible à rémunération",
                    "reason": "\n\n{reason}",
                    "notChargeableOperation": "Processus non éligible. {reasonsText}",
                    "partiallyChargeable": "{chargeableCount} sur {totalCount} positions sont éligibles. {reasonsText}",
                    "fullyChargeable": "Toutes les positions du processus sont éligibles"
                }
            }
        },
        "priceWizard": {
            "priceWizard": "Assistant prix",
            "showPricewizard": "Afficher l’assistant prix",
            "applyConfirmation": "Confirmation d’application",
            "applyPriceGroupPrompt": "Souhaitez-vous appliquer le groupe de prix au processus complet ou uniquement à cette position ?",
            "applyRestricted": "appliquer à la position",
            "applyEntireOperation": "appliquer à l’ensemble du processus",
            "applyMarginWarning": "Votre prix de vente est inférieur à votre prix d’achat. Voulez-vous continuer ?",
            "resetConfirmation": "Cela réinitialise toutes les modifications depuis la dernière sauvegarde.",
            "priceGroupNotModified": "Groupe tarifaire non modifié.",
            "sellingPrice": "Prix de vente",
            "inputInEUR": "Indiqué en EUR",
            "additionalPositionNumber": "N° position suppl.",
            "quantity": "Qté",
            "RRP": "PVC",
            "sale": "Remise",
            "discount": "Remise",
            "inputInPercent": "Indiqué en %",
            "specificationInEur": "Indiqué en EUR",
            "subtotal": "Sous-total",
            "surcharge": "Majoration",
            "currentPurchasePrice": "Prix d’achat actuel",
            "difference": "Différence",
            "originalPurchasePrice": "Prix d’achat d’origine",
            "basisForCalculations": "(Base de calcul)",
            "purchasePrice": "Prix d’achat",
            "entirePriceGroup": "Groupe tarifaire complet",
            "selectPriceGroup": "Sélectionner le groupe tarifaire",
            "showDiscountPDFs": "Afficher la remise dans les PDF d’offre et de confirmation",
            "costType": "Type de coût",
            "net": "Net",
            "gross": "Brut",
            "percentageInput": "Indiqué en %",
            "closeIcon": "Fermer",
            "searchIcon": "Rechercher",
            "editEndcustomerAddress": "Modifier l’adresse du client final"
        },
        "richtext": {
            "bold": "Gras",
            "italic": "Italique",
            "underline": "Souligné",
            "strike": "Barré",
            "align": "Alignement",
            "blockquote": "Citation",
            "code_block": "Code",
            "list": "Liste",
            "color": "Couleur du texte",
            "background": "Couleur d’arrière-plan",
            "image": "Insérer une image",
            "link": "Insérer un lien",
            "clean": "Effacer la mise en forme",
            "priceGroupNotModified": "Le groupe tarifaire n’a pas été modifié."
        },
        "datepicker": {
            "days": [
                "dimanche",
                "lundi",
                "mardi",
                "mercredi",
                "jeudi",
                "vendredi",
                "samedi"
            ],
            "daysShort": [
                "Dim",
                "Lun",
                "Mar",
                "Mer",
                "Jeu",
                "Ven",
                "Sam"
            ],
            "daysMin": [
                "Di",
                "Lu",
                "Ma",
                "Me",
                "Je",
                "Ve",
                "Sa"
            ],
            "months": [
                "janvier",
                "février",
                "mars",
                "avril",
                "mai",
                "juin",
                "juillet",
                "août",
                "septembre",
                "octobre",
                "novembre",
                "décembre"
            ],
            "monthsShort": [
                "Jan",
                "Fév",
                "Mar",
                "Avr",
                "Mai",
                "Juin",
                "Juil",
                "Aoû",
                "Sep",
                "Oct",
                "Nov",
                "Déc"
            ],
            "today": "Aujourd’hui",
            "clear": "Effacer",
            "titleFormat": "MM yyyy",
            "format": "dd.mm.yyyy"
        },
        "overlay": {
            "closeOffer": "Fermer l’offre",
            "unsavedChanges": "Des modifications non enregistrées existent. Voulez-vous vraiment fermer l’offre ?"
        },
        "followUp": {
            "removeResubmissionDate": "Supprimer la date de relance",
            "setResubmissionDate": "Définir la date de relance",
            "onlyEditResubmissions": "Vous ne pouvez modifier que vos propres relances."
        },
        "documentTemplate": {
            "template": "Modèle",
            "offerTemplate": "Modèle d'offre",
            "orderConfirmationTemplate": "Modèle de confirmation de commande",
            "offerTemplateGotSaved": "Modèle d'offre enregistré avec succès.",
            "filesAllowed": "Seuls les fichiers png et jpg/jpeg sont autorisés.",
            "resetToDefault": "Réinitialiser par défaut",
            "letterPaper": "Papier à en-tête",
            "defineLayoutThroughBGImages": "Définir la mise en page à l’aide d’image(s) de fond",
            "defineLayoutThroughLogo": "Définir la mise en page à l’aide du fichier logo",
            "logoPosition": "Position du logo",
            "verticalOrientation": "Alignement vertical",
            "horizontalOrientation": "Alignement horizontal",
            "verticalDisplacement": "Déplacement vertical",
            "horizontalDisplacement": "Déplacement horizontal",
            "noLogoAvailable": "Aucun logo disponible pour le moment",
            "deleteFile": "Supprimer le fichier",
            "footer": "Pied de page",
            "noFooterAvailable": "Aucun pied de page disponible pour le moment",
            "firstPage": "Première page",
            "noTemplateAvailable": "Aucun modèle disponible pour le moment",
            "templateNotModified": "Le modèle n’a pas été modifié.",
            "subsequentPages": "Pages suivantes",
            "margins": "Marges de la page",
            "top": "Haut",
            "right": "Droite",
            "bottom": "Bas",
            "left": "Gauche",
            "forSubsequentPages": "sur les pages suivantes",
            "preview": "Aperçu",
            "mandatoryField": "Champ obligatoire",
            "textContent": "Contenu du texte",
            "contact": "Personne de contact",
            "defaultContactPerson": "Par défaut, l’utilisateur connecté est utilisé comme contact. Vous pouvez désactiver cela dans \"Modifier le modèle\".",
            "displayedContactPerson": "Personne de contact affichée dans l’en-tête du modèle*",
            "eMailOfContact": "Email de la personne de contact*",
            "useLoggedInUserAsContact": "Utiliser l’utilisateur connecté comme personne de contact.",
            "telephoneOfContact": "Numéro de téléphone de la personne de contact*",
            "currentLoggedInUser": "Utilisateur actuellement connecté :",
            "emailContent": "Texte de l’email",
            "emailSubject": "Objet de l’email*",
            "subjectLine": "Ceci est une ligne d'objet",
            "emailBody": "Corps de l’email",
            "pdfContent": "Textes PDF",
            "introductionText": "Texte d’introduction",
            "introContent": "Ceci est le texte d’introduction",
            "originalCoverLetter": "Lettre de motivation originale",
            "closingNote": "Note de clôture (affichée après la liste des articles)",
            "closingText": "Ceci est le texte de clôture",
            "coverLetter": "Lettre de motivation",
            "deliveryTimeAndPaymentTerms": "Délais de livraison et conditions de paiement*",
            "deliveryTime": "Délais de livraison",
            "paymentTermsDescription": "Description des conditions de paiement",
            "emailBodyPlaceholder": "Ceci est la lettre de motivation",
            "paymentTerms": "Conditions de paiement*",
            "editTemplate": "Modifier le modèle"
        },
        "pcalc": {
            "originType": "Type d’origine",
            "uvp": "PVC",
            "markupOnPurchasePrice": "Marge sur prix d’achat",
            "discountOnRRP": "Remise sur le PVC",
            "minMarginOnPurchasePrice": "Marge minimale sur prix d’achat",
            "addPriceGroup": "Ajouter un groupe tarifaire",
            "priceCalculation": "Calcul du prix",
            "globalPriceCalculation": "Calcul global du prix",
            "priceGroups": "Groupes tarifaires",
            "updateSuccess": "Les modifications ont été enregistrées avec succès.",
            "updateError": "Les modifications n’ont pas pu être enregistrées.",
            "createSuccess": "Le calcul du prix a été enregistré avec succès.",
            "createError": "Le calcul du prix n’a pas pu être enregistré.",
            "deleteSuccess": "Le calcul du prix a été supprimé avec succès.",
            "deleteError": "Le calcul du prix n’a pas pu être supprimé.",
            "defaultCalculation": "Calcul par défaut",
            "groupNamePlaceholder": "Nom du groupe",
            "editGroupName": "Modifier le nom du groupe",
            "deleteGroup": "Supprimer le groupe",
            "resetTooltip": "Cela réinitialise toutes les modifications depuis la dernière sauvegarde.",
            "reset": "Réinitialiser",
            "invalid": "Invalide",
            "notModified": "Le groupe tarifaire n’a pas été modifié.",
            "validity": "Validité",
            "daysValidPlaceholder": "ex. 14",
            "days": "Jours",
            "fixedDates": "Dates fixes",
            "datePlaceholder": "De",
            "internalComment": "Commentaire interne",
            "commentNote": "(n’apparaît sur aucun document)",
            "commentPlaceholder": "Votre commentaire pour la date",
            "addFixedDate": "Ajouter une date fixe",
            "exceptionRule": "Règle d’exception",
            "exceptionRules": "Règles d’exception",
            "youCanIndivualize": "Vous pouvez personnaliser le calcul via les champs « Attribut », « Opérateur de comparaison » et « Valeur » (plusieurs choix possibles pour la valeur).",
            "processedTopBottom": "Les règles sont appliquées de haut en bas.",
            "filter": "Filtre",
            "addExceptionRule": "Ajouter une règle d’exception",
            "exceptionRuleTitle": "Titre de la règle d’exception",
            "removeFilter": "Supprimer le filtre",
            "comparisonOperator": "Opérateur de comparaison",
            "installationType": "Type d’installation",
            "netPrice": "Prix net",
            "residentialUnitsCount": "Unités résidentielles",
            "residentialUnitsCountTotal": "Total unités résidentielles",
            "productGroup": "Groupe de produits",
            "modelGroup": "Groupe de modèles",
            "equalsExample": "Égal (ex. 5 = 5)",
            "notEqualsExample": "Différent (ex. 5 ≠ 3)",
            "greaterExample": "Supérieur (ex. 5 > 3)",
            "lessExample": "Inférieur (ex. 3 < 5)",
            "greaterOrEqualExample": "Supérieur ou égal (ex. 5 ≥ 5)",
            "lessOrEqualExample": "Inférieur ou égal (ex. 3 ≤ 5)",
            "attribute": "Attribut"
        },
        "pcalcGroup": {
            "priceGroup": "Groupe tarifaire",
            "globalPriceGroup": "Groupe tarifaire global",
            "dealerNr": "N° revendeur",
            "selectPriceGroup": "Sélectionner un groupe tarifaire",
            "manualInput": "Saisie manuelle",
            "activePriceGroup": "Groupe tarifaire actif",
            "changePriceGroup": "Modifier le groupe tarifaire",
            "applyPriceGroup": "Appliquer le groupe tarifaire",
            "inclusive": "incl.",
            "vat": "TVA",
            "gotApplied": "Le groupe tarifaire a été appliqué avec succès."
        },
        "noOffer": "Aucune offre",
        "operationsFilter": {
            "all": "tous",
            "taskSent": "Confirmation de commande envoyée",
            "offerSent": "Offre envoyée",
            "user_status": "Statut utilisateur",
            "internal_status": "Statut interne",
            "undefined": "Tous les statuts",
            "inProgress": "En cours",
            "created": "Offre créée",
            "outOfferCreated": "Offre sortante créée",
            "ordered": "Commandé",
            "open_dealer": "Ouvert",
            "lost_dealer": "Perdu",
            "won_dealer": "Gagné",
            "waitingForResponse_dealer": "En attente de réponse",
            "followup_dealer": "Relance",
            "locked_dealer": "Verrouillé",
            "open_internal": "Ouvert",
            "lost_internal": "Perdu",
            "won_internal": "Gagné",
            "waitingForResponse_internal": "En attente de réponse",
            "followup_internal": "Relance",
            "locked_internal": "Verrouillé",
            "confirmed": "Confirmation de commande",
            "inObjectionPeriod": "En période de réclamation",
            "delayed": "Retard de livraison",
            "manufactured": "En production",
            "readyToShip": "Prêt à l’expédition",
            "inShipment": "Expédié",
            "delivered": "Livré",
            "canceled": "Annulé",
            "applyFilter": "Appliquer le filtre",
            "resetFilter": "Réinitialiser le filtre",
            "agent": "Gestionnaire",
            "selectAgent": "Sélectionner un gestionnaire",
            "representative1": "Représentant 1",
            "selectRepresentative": "Sélectionner un représentant",
            "selectModelGroup": "Sélectionner un groupe de modèles",
            "modelGroup": "Groupe de modèles",
            "installationType": "Type de montage",
            "selectInstallationType": "Sélectionner le type de montage",
            "residentialUnits": "Unités résidentielles",
            "unitPrice": "Prix unitaire",
            "advancedSearch": "Recherche avancée",
            "dealerCustomers": "Clients revendeurs",
            "enterNumberOrName": "Entrer numéro / nom",
            "until": "jusqu'à",
            "filterTimeRange": "Filtrer la période",
            "from": "de",
            "freeSearch": "Recherche libre",
            "allSources": "Toutes les sources",
            "origin": "Origine",
            "selectOrigin": "Sélectionner l’origine",
            "selectStatus": "Sélectionner le statut",
            "status": "Statut",
            "filter": "Filtrer"
        },
        "operationProtocol": {
            "protocolForOffer": "Protocole pour l’offre {number}",
            "noProtocol": "Aucun protocole disponible pour cette offre.",
            "timestamp": "Horodatage",
            "action": "Action",
            "editor": "Modifié par",
            "details": "Détails",
            "legend": "Légende",
            "emailSent": "E-mail envoyé",
            "added": "Ajouté",
            "created": "Créé",
            "edited": "Modifié",
            "close": "Fermer",
            "protocol": "Protocole",
            "operationChanges": "Modifications du processus",
            "fieldName": "Nom du champ",
            "previousValue": "Valeur précédente",
            "currentValue": "Valeur actuelle",
            "noPreviousEntry": "Aucune entrée précédente",
            "noCurrentEntry": "Aucune entrée actuelle",
            "creationOrderConfirmation": "création de la confirmation de commande",
            "creationOffer": "création de l'offre",
            "processingOrderConfirmation": "traitement de la confirmation de commande",
            "processingOffer": "traitement de l'offre"
        },
        "date": {
            "dateDeleteValidationModal": {
                "question": "Souhaitez-vous vraiment supprimer cette date ?",
                "cancelButton": "annuler",
                "deleteButton": "oui"
            },
            "followUpDeleteValidationModal": {
                "question": "Souhaitez-vous vraiment retirer ce processus de la liste de favoris ?",
                "cancelButton": "annuler",
                "deleteButton": "oui"
            }
        }
    },
    "config": {
        "open": "Ouvert",
        "lost": "Perdu",
        "won": "Gagné",
        "locked": "Verrouillé",
        "waitingForResponse": "En attente de réponse",
        "followup": "Relance",
        "country": {
            "DE": "Allemagne",
            "AT": "Autriche",
            "SE": "Suède",
            "LU": "Luxembourg",
            "BE": "Belgique"
        },
        "hints": {
            "placeholderHint": "Vous pouvez insérer les espaces réservés suivants :<br />[Nummer]<br />[Firma]<br />[Vorname]<br />[Nachname]<br />[Bauvorhaben]<br />[Kommission]",
            "imageFormatHint": "Le format de l’image doit être .jpg ou .png. La résolution optimale est de 2480x3508 pixels. D'autres tailles sont possibles, l'application redimensionne automatiquement, mais la qualité peut en pâtir.",
            "imageSimpleFormatHint": "Le format de l’image doit être .jpg ou .png. Résolution optimale : logo = 1240x680 pixels ; pied de page = 2480x240 pixels (env. 3 cm de hauteur). Autres tailles possibles, mais une perte de qualité peut se produire."
        },
        "shippingCompanies": {
            "1003": "DPD",
            "1004": "Transport Kirchberg/Murr",
            "1005": "Transport Häring",
            "1006": "Transport Kunzendorf",
            "1007": "Transport Franz Lerner GmbH",
            "1010": "Elmar Maurus Logistic",
            "1011": "Transport Ulmschneider",
            "1012": "DHL Freight GmbH",
            "1013": "Transport Weckerle",
            "1014": "Transport H. v. Wirth",
            "1017": "UPS",
            "1023": "Transport Redemann",
            "1032": "Transport Dachser",
            "1044": "Transport Gert Treitinger",
            "1045": "Transport Rentschler",
            "1046": "DSV Stuttgart",
            "1047": "TNT",
            "1048": "Transport Dischinger Ebersbach",
            "1049": "Transport Atege",
            "1051": "Transport Schmalz + Schön",
            "1053": "Transport SCS Stuttgart GmbH",
            "1054": "Transport L.W.Cretschmar GmbH&Co.KG",
            "1055": "Transport Trautwein",
            "1056": "Transport L.Wackler Wwe.Nachf.GmbH",
            "1057": "Transport Dacotrans Grosskopf GmbH & Co.KG",
            "1058": "Ebenroth - Logistique pure",
            "1059": "HTL-Peter Messner GmbH / Commerce-Transport-Logistique",
            "1060": "Kunzendorf Sped. GmbH / Agence Schkeuditz",
            "1061": "Transport ROHLIG SUUS Logistics SA",
            "1062": "Optimal Kurier",
            "1063": "Heppner Internationale / Transport GmbH Co. KG",
            "1064": "DACHSER SE Transport",
            "1065": "Renz France (FR)",
            "1066": "Renz Pologne (PL)",
            "1067": "Inotherm (SI)",
            "1068": "Kühne + Nagel"
        },
        "operationSources": {
            "10": {
                "label": "Back Office"
            },
            "20": {
                "label": "eConfig Pro"
            },
            "30": {
                "label": "eConfig"
            },
            "40": {
                "label": "RIT"
            },
            "50": {
                "label": "eShop"
            },
            "60": {
                "label": "eInfo"
            }
        },
        "installationTypeCodes": {
            "1": "Montage encastrée / partielle murale",
            "2": "Montage en saillie",
            "3": "Montage autoportant, retrait avant",
            "4": "Montage autoportant, retrait arrière",
            "5": "Montage traversant mural",
            "6": "Montage sur clôture",
            "7": "Montage latéral porte, retrait arrière",
            "8": "Colonne de contact",
            "9": "Montage traversant avec boîtes horizontales",
            "10": "Montage individuel",
            "11": "Montage latéral porte, retrait avant",
            "12": "Portes/couvercles/boîtiers de remplacement",
            "13": "Façades spécifiques client",
            "14": "Montage traversant mural (Suisse uniquement)"
        },
        "productGroupCodes": {
            "1": "Renz",
            "2": "Startline",
            "3": "Renz Plan"
        },
        "modelGroupCodes": {
            "10": "Boîtes aux lettres verticales, retrait avant",
            "12": "Boîtes latérales porte, retrait arrière",
            "13": "Boîtes horizontales, retrait avant",
            "14": "Montage mural, retrait arrière",
            "15": "Ligne Commercial / Ligne Privée",
            "16": "Systèmes interphone / sonnette",
            "17": "Boîtes sur clôture / composants individuels",
            "20": "Systèmes de stockage",
            "21": "Distributeurs courrier traversant",
            "22": "Distributeurs courrier frontaux",
            "23": "Systèmes lettres/colis CLASSIC",
            "25": "Startline vertical, retrait avant",
            "26": "Startline horizontal, retrait avant",
            "27": "Startline latéral porte, retrait arrière",
            "29": "Budget latéral porte, retrait arrière",
            "30": "Boîtes d’information",
            "40": "Boîtes concessionnaires auto",
            "41": "Boîtes pharmacie",
            "42": "Boîtes sécurisées",
            "43": "Boîtes jour/nuit",
            "50": "Modèles export Suisse",
            "58": "Budget horizontal, retrait avant",
            "60": "RENZ PLAN vertical, retrait avant",
            "61": "RENZ PLAN horizontal, retrait avant",
            "62": "RENZ PLAN vertical, retrait arrière",
            "63": "RENZ PLAN colonnes",
            "64": "RENZ PLAN S latéral porte",
            "65": "RENZ PLAN S mural, retrait arrière",
            "67": "RENZ PLAN S vertical, retrait avant",
            "68": "RENZ PLAN SL horizontal, Suisse",
            "78": "MEFA",
            "90": "Pièces détachées avec gravure",
            "97": "Pièces détachées"
        }
    },
    "general": {
        "foldIn": "Replier",
        "removeExceptionFilter": "Supprimer le filtre. Remarque : une règle d'exception sans filtre sera automatiquement supprimée lors de l’enregistrement.",
        "exceptionWithoutFilter": "Les règles d’exception sans filtre seront automatiquement supprimées. Enregistrez les calculs universels en dehors des règles d’exception.",
        "foldOut": "Déplier",
        "logoutWarning": "Vous serez déconnecté dans {logoutInMinutes} minute{plural} si aucune action n’est effectuée.",
        "errorOccurred": "Une erreur s’est produite ! Veuillez recharger la page et réessayer plus tard.",
        "fullText": "Texte complet",
        "removeFilter": "Supprimer le filtre",
        "warning": "Avertissement",
        "pushDown": "Déplacer vers le bas",
        "pushUp": "Déplacer vers le haut",
        "restore": "Restaurer",
        "ok": "OK",
        "yes": "Oui",
        "no": "Non",
        "send": "Envoyer",
        "cancel": "Annuler",
        "save": "Enregistrer",
        "close": "Fermer",
        "back": "Retour",
        "next": "Suivant",
        "delete": "Supprimer",
        "edit": "Modifier",
        "noted": "Marqué",
        "note": "Marquer",
        "beeingLoaded": "Chargement en cours...",
        "pleaseWait": "Veuillez patienter...",
        "preview": "Aperçu",
        "logo": "Logo",
        "selectFile": "Sélectionner un fichier",
        "legend": "Légende",
        "eMailAddress": "Adresse e-mail",
        "telephone": "Numéro de téléphone",
        "webAddress": "Adresse web",
        "add": "Ajouter",
        "mr": "Monsieur",
        "mrs": "Madame",
        "others": "Autre",
        "planned": "prévu",
        "origin": "Origine",
        "positionShortName": "Pos.",
        "dealerDataNotFound": "Données du revendeur introuvables",
        "commission": "Commission",
        "offer": "Offre",
        "order": "Commande",
        "actions": "Actions",
        "loadMore": "... charger plus",
        "type": "Type",
        "selectType": "Sélectionner un type",
        "pageNotFound": "Page non trouvée<br /><br />Chemin : {path}",
        "mandatoryField": "Champ obligatoire",
        "dataStored": "Données enregistrées",
        "description": "Description",
        "and": "et",
        "rule": "Règle",
        "units": "Unités",
        "lookForValue": "Rechercher une valeur",
        "copy": "Copier",
        "share": "Partager",
        "entrance": "Entrée",
        "exit": "Sortie",
        "reset": "⟳ réinitialiser",
        "apply": "Appliquer",
        "email": "E-mail",
        "phone": "Tél.",
        "duplicate": "Dupliquer",
        "accessKeyCreated": "Clé d’accès créée.",
        "accessKeyDeleted": "Clé d’accès supprimée.",
        "newVersionAvailable": "Une nouvelle version du logiciel est disponible.<br>La page va être rechargée.",
        "incompleteInfo": "Toutes les informations<br>ne sont pas encore disponibles.<br><br>Veuillez réessayer plus tard."
    }
}